import { getEnv } from '../utils/environment';
import { simplePost } from './customFetch';

const POST_GET_TAX_RATE_ENDPOINT = '/api/v1/get-tax-rate';

export type ShippingCountry = 'CA' | 'GB' | 'US';

export interface TaxResponseError {
  msg: string;
}
// TODO we should convert snake cased attributes to camelCased
// or at least converge to something consistent (matt 8.17.23)
export interface TaxResponse {
  customer_message?: string;
  errors?: TaxResponseError[];

  tax_rate?: string;
}

const shippingCountriesMinZipLength: Record<ShippingCountry, number> = {
  US: 5,
  GB: 6,
  CA: 6,
};

const processableCountryAndZip = (shipCountry: ShippingCountry, zipCode: string): boolean => {
  if (
    !shippingCountriesMinZipLength[shipCountry] ||
    !zipCode ||
    zipCode.length < shippingCountriesMinZipLength[shipCountry]
  )
    return false;
  return true;
};

export const getTaxRate = (
  shipCountry: ShippingCountry,
  shipZip: string,
  plan: string,
): Promise<TaxResponse | void> => {
  if (!processableCountryAndZip(shipCountry, shipZip)) return Promise.resolve();
  return simplePost(`${getEnv().taxBaseUrl}${POST_GET_TAX_RATE_ENDPOINT}`, {
    ship_country: shipCountry,
    zip_code: shipZip,
    plan,
  });
};
